class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    super.updateOptions();
    super.updateVariant();
    super.toggleAddButton(false, '');
    super.handleErrorMessage();
    super.filterOptions();

    if (!this.currentVariant) {
      super.toggleAddButton(true, '');
      super.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      super.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    super.updateVariantInput();
    this.renderProductInfo();
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  renderPrice() {
    const destinationPrice = document.querySelector(
      `#price-${this.dataset.sectionId}`,
    );

    if (destinationPrice && this.currentVariantPrice?.price_html) {
      destinationPrice.classList.remove('visually-hidden');
      destinationPrice.innerHTML = this.currentVariantPrice.price_html;
    }
  }

  updateColors() {
    this.currentRadio = this.querySelector('[type="radio"]:checked');

    this.closest('section').style.setProperty('--background-color', this.currentRadio.getAttribute('data-radio-background'));
    this.closest('section').style.setProperty('--radio-color', this.currentRadio.getAttribute('data-radio-color'));
  }

  toggleMarshmallows() {
    document.querySelectorAll('[js-marshmallow]').forEach(element => {
      element.classList.toggle('hidden', !this.currentVariant.title.toLowerCase().includes('marshmallow'));
    });
  }

  toggleDescription() {
    const allDescriptionElements = document.querySelectorAll(`[js-variant-description]`);
    const activeDescription = document.querySelector(`[js-variant-description="${this.currentVariant.id}"]`);
    const defaultDescription = document.querySelector('[js-variant-description="default"]');

    allDescriptionElements.forEach(element => element.classList.add('hidden'));

    if(activeDescription) activeDescription.classList.remove('hidden');
    if(!activeDescription && defaultDescription) defaultDescription.classList.remove('hidden');
  }

  toggleTitle() {
    const allTitles = document.querySelectorAll(`[js-title]`);
    const defaultTitle = document.querySelector(`[js-title="default"]`);
    const activeTitle = document.querySelector(`[js-title="${this.currentVariant.id}"]`);

    allTitles.forEach(element => element.classList.add('hidden'));

    if(activeTitle) activeTitle.classList.remove('hidden');
    if(!activeTitle && defaultTitle) defaultTitle.classList.remove('hidden');
  }

  renderProductInfo() {
    this.renderPrice();
    this.updateColors();
    this.toggleMarshmallows();
    this.toggleDescription();
    this.toggleTitle();
  }
}

customElements.define('main-product-selector', MainProductSelector);
